
import Injection = EECore.Injection;
import NewsModelList from "../entities/news/newsModelList";

export const SITECORE_API_KEY = "{BBEC7EE2-E0B1-4041-90F4-80CA08BACE59}";
export const DEFAULT_CONTENT_PATH = "/dashboard";

@Injection.injectableClass("EEWidget.NewsService")
export default class NewsService {

  @Injection.injectableProperty("EEWidget.NewsService", EECore.Registrations.CONTENT_SERVICE)
  private contentService: EECore.Services.ContentService;

  @Injection.injectableProperty("EEWidget.NewsService", EECore.Registrations.LOB_HELPER)
  private lobHelper: EECore.LobHelper;

  @Injection.injectableProperty("EEWidget.NewsService", EECore.Registrations.AUTH_SERVICE)
  private authService: EECore.Services.AuthService;

  @Injection.injectableProperty("EEWidget.NewsService", EECore.Registrations.INTEGRATION_CONTEXT)
  private integrationContext: EECore.Integration.Context;

  constructor(contentService: EECore.Services.ContentService, lobHelper: EECore.LobHelper, authService: EECore.Services.AuthService, integrationContext: EECore.Integration.Context) {
    this.contentService = contentService;
    this.lobHelper = lobHelper;
    this.authService = authService;
    this.integrationContext = integrationContext;
  }

  getLatest(contentPath: string = DEFAULT_CONTENT_PATH) {
    const lobCode = this.getLobCode();
    const newsApplicationPath = this.getNewsApplicationPath(lobCode);

    if (!contentPath) contentPath = DEFAULT_CONTENT_PATH;

    return new EECore.Promise<NewsModelList, string>((resolve, reject) => {
      const contentRequest = this.contentService.getContent(contentPath, "news");

      contentRequest.then((newsList) => {
        const newsListModel = new NewsModelList();
        newsListModel.url = newsApplicationPath;
        newsListModel.news = [];
        let newsEntities = newsList[0].fields;
        newsEntities = newsEntities.sort((a: any, b: any) => { return (new Date(b.activationDate) as any) - (new Date(a.activationDate) as any); });
        for (let i = 0; i < newsEntities.length; i++) {
          const newsEntity = newsEntities[i];
          newsListModel.news.push({
            id: newsEntity.id,
            url: `${newsApplicationPath}?id=${newsEntity.id}`,
            date: newsEntity.newsDate,
            summary: newsEntity.summary,
            title: newsEntity.title
          });
        }

        resolve(newsListModel);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  private getLobCode() {
    if (this.integrationContext.experience.company !== "IA" || this.integrationContext.experience.audience === EECore.Integration.Audience.Client)
      return "";

    let currentLobCode = this.lobHelper.getCurrentLobCode();
    if (this.integrationContext.experience.audience === EECore.Integration.Audience.Employee && this.authService.isAuthenticated() && this.authService.isSalEmployee())
      currentLobCode = "SAL";

    return currentLobCode;
  }

  private getNewsApplicationPath(lobCode: string) {
    const validLobs = ["IND", "ERC", "AC", "SAL"];

    if (validLobs.indexOf(lobCode.toUpperCase()) >= 0)
      return `/wemwpn43/${lobCode.toLowerCase()}/`;

    return "/wemwpn43/";
  }
}